import React, { useContext } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useCountryService from '../../../app/services/hooks/useCountryService';

interface Props {
    countryId: number;
    checkValue: boolean;
    callbackSuccess?: () => void;
}

const CountrySwitchChange = ({ countryId, checkValue, callbackSuccess = undefined }: Props) => {
    const { hideLoading } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);
    const { activeCountry } = useCountryService();

    const active = (value: boolean) => {
        setChecked(value);
        activeCountry(countryId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                if (callbackSuccess) callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={countryId} callback={active} />;
};

export default CountrySwitchChange;
